const computedElementStyles = new WeakMap();

export const FOCUSABLES_SELECTOR = 'a[href], button, input, select, textarea, details, [tabindex]';

export function isElementFocusable( element ) {
	if ( element.disabled ) {
		return false;
	}

	if ( element.tabIndex < 0 ) {
		return false;
	}

	if ( element.getAttribute( 'aria-selected' ) === 'false' ) {
		return false;
	}

	if ( element.style.display === 'none' ) {
		return false;
	}

	if ( element.style.visibility === 'hidden' ) {
		return false;
	}

	if ( element.style.position !== 'fixed' && ! element.offsetParent ) {
		return false;
	}

	// Last check, visibility
	let computedStyle = computedElementStyles.get( element );
	if ( ! computedStyle ) {
		computedStyle = getComputedStyle( element );
		// Cache the computed style, since it's live and
		// getComputedStyle returns a new object each time
		computedElementStyles.set( element, computedStyle );
	}

	if ( computedStyle.visibility === 'hidden' ) {
		return false;
	}

	return true;
}
